import { Component } from "react";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("App error boundary caught:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div data-testid="app-error-fallback" style={{
          minHeight: "70vh", display: "flex", flexDirection: "column", alignItems: "center",
          justifyContent: "center", gap: "12px", textAlign: "center", padding: "24px",
          fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif", color: "#0f172a",
        }}>
          <h1 style={{ fontSize: "22px", fontWeight: 800 }}>Something went wrong</h1>
          <p style={{ color: "#64748b", maxWidth: "420px" }}>
            An unexpected error occurred. Please reload the page — if it keeps happening, let us know.
          </p>
          <button data-testid="app-error-reload" onClick={() => window.location.reload()} style={{
            background: "#0f172a", color: "#fff", borderRadius: "9999px", padding: "10px 22px",
            border: "none", cursor: "pointer", fontWeight: 600,
          }}>Reload</button>
        </div>
      );
    }
    return this.props.children;
  }
}
